import React, { useEffect, useState } from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';

interface OrgNameFormProps {
  initialName?: string;
  onSubmit: (name: string) => void;
}

export const OrgNameForm: React.FC<OrgNameFormProps> = ({
  initialName = '',
  onSubmit,
}) => {
  const [name, setName] = useState(initialName);
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (name.length < 2) {
      setError('Organization name must be at least 2 characters');
      return;
    }

    setError('');
    onSubmit(name);
  };

  useEffect(() => {
    setName(initialName);
  }, [initialName]);

  return (
    <Box
      component="form"
      noValidate
      autoComplete="off"
      onSubmit={handleSubmit}
      sx={{ maxWidth: 400, flex: 1 }}
    >
      <TextField
        label="Organization Name"
        fullWidth
        margin="normal"
        value={name}
        onChange={(e) => setName(e.target.value)}
        error={name.length > 0 && name.length < 2}
        helperText={
          name.length > 0 && name.length < 2
            ? 'Name must be at least 2 characters'
            : ''
        }
      />
      {error && (
        <Typography color="error" variant="body2" sx={{ mb: 2 }}>
          {error}
        </Typography>
      )}
      <Button
        type="submit"
        variant="contained"
        color="primary"
        sx={{ mt: 2, mx: 'auto', display: 'block' }}
      >
        Save
      </Button>
    </Box>
  );
};
